import PropTypes from "prop-types";
import CurrencySelector from "./CurrencySelector";
// import { Icon, IconButton } from "@mui/material";

const RANGE_OPTIONS = ["7D", "30D", "90D", "12M"];

function OverviewHeader({ selectedRange, onRangeChange, knowledgeBase, agency, Update, currency, onCurrencyChange }) {
  return (
    <>
      <style>
        {`
       .kb-help-text-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
}

.kb-help-text-btn:hover {
  background: #eef2ff;
  color: #2f80ed;
  border-color: #c7d2fe;
}

`}
      </style>
      <div className="sd-overview__header sd-overview__header--toolbar">
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", alignItems: "center" }}>
          {!agency?.load_dummy_data && (
            <div
              style={{
                background: "#fff7ed",
                color: "#9a3412",
                padding: "10px 14px",
                borderRadius: "6px",
                fontSize: "13px",
                border: "1px solid #fed7aa",
                marginBottom: "10px",
                display: "inline-block",
              }}
            >
              ⏳ Preparing your dummy data... Please wait a moment while we load the
              dummy data.Thankyou for your patience!
            </div>
          )}
        </div>
        <div className="sd-overview__header-controls">
          <CurrencySelector currency={currency} onChange={onCurrencyChange} agency={agency} Update={Update} />
          <div className="sd-range-switch">
            {RANGE_OPTIONS.map((option) => {
              const isActive = selectedRange === option;

              return (
                <button
                  type="button"
                  key={option}
                  className={`sd-range-switch__item ${isActive ? "is-active" : ""}`}
                  onClick={() => onRangeChange(option)}
                >
                  {option}
                </button>
              );
            })}
          </div>
          {/* <IconButton className="sd-icon-btn" aria-label="work" size="small">
          <Icon>work_outline</Icon>
        </IconButton> */}
        </div>
      </div>
    </>
  );
}

OverviewHeader.propTypes = {
  selectedRange: PropTypes.string.isRequired,
  onRangeChange: PropTypes.func.isRequired,
};

export default OverviewHeader;
